// extracted by mini-css-extract-plugin
export default {"version":"version_version__LPz5a"};